import Vue from 'vue';
import Vuex from 'vuex';
import app from '../modules/app/store';
import mainView from '../modules/mainView/store';
import settings from '../modules/settings/store';
import feedbackButton from '../shared/reybex/feedbackButton/store';
import activityReport from '../modules/activityReport/store';
import userList from '../modules/userList/store';
import userDetails from '../modules/userDetails/store';
import affiliateList from '../modules/affiliateList/store';
import affiliateDetails from '../modules/affiliateDetails/store';
import privacyAuditList from '../modules/privacyAuditList/store';
import privacyAuditDetails from '../modules/privacyAuditDetails/store';
import questionaryList from '../modules/questionaryList/store';
import questionaryDetails from '../modules/questionaryDetails/store';
import tomList from '../modules/tomList/store';
import tomDetails from '../modules/tomDetails/store';
import procedureDirectoryList from '../modules/procedureDirectoryList/store';
import procedureDirectoryDetails from '../modules/procedureDirectoryDetails/store';
import companyList from '../modules/companyList/store';
import companyDetails from '../modules/companyDetails/store';
import clientList from '../modules/clientList/store';
import clientDetails from '../modules/clientDetails/store';
import resellerUser from '../modules/resellerUser/store';
import resellerAgentList from '../modules/resellerAgentList/store';
import resellerAgent from '../modules/resellerAgent/store';
import organizationalUnitList from '../modules/organizationalUnitList/store';
import organizationalUnitDetails from '../modules/organizationalUnitDetails/store';
import employeeList from '../modules/employeeList/store';
import employeeDetails from '../modules/employeeDetails/store';
import taskList from '../modules/taskList/store';
import notes from '../modules/notes/store';
import documents from '../modules/documents/store';
import attachment from '../modules/attachment/store';
import history from '../modules/history/store';
import avContractList from '../modules/avContractList/store';
import avContractDetails from '../modules/avContractDetails/store';
import trainingList from '../modules/trainingList/store';
import training from '../modules/training/store';
import trainingEditor from '../modules/trainingEditor/store';
import trainingEditorList from '../modules/trainingEditorList/store';
import departmentList from '../modules/departmentList/store';
import departmentDetails from '../modules/departmentDetails/store';
import blogEntryList from '../modules/blogEntryList/store';
import blogEntryDetails from '../modules/blogEntryDetails/store';
import infoPortal from '../modules/infoPortal/store';

Vue.use(Vuex);

export const storeOptions = {
  modules: {
    app,
    mainView,
    settings,
    feedbackButton,
    activityReport,
    history,
    userList,
    userDetails,
    taskList,
    notes,
    documents,
    attachment,
    affiliateList,
    affiliateDetails,
    privacyAuditList,
    privacyAuditDetails,
    questionaryList,
    questionaryDetails,
    tomList,
    tomDetails,
    procedureDirectoryList,
    procedureDirectoryDetails,
    companyList,
    companyDetails,
    clientList,
    clientDetails,
    resellerUser,
    resellerAgentList,
    resellerAgent,
    organizationalUnitList,
    organizationalUnitDetails,
    employeeList,
    employeeDetails,
    avContractList,
    avContractDetails,
    training,
    trainingList,
    trainingEditor,
    trainingEditorList,
    departmentList,
    departmentDetails,
    blogEntryList,
    blogEntryDetails,
    infoPortal,
  },
};

export default new Vuex.Store(storeOptions);
